import logo from "../../assets/logo.svg"

const Logo = () => {
  return (
    <img src={logo} alt="logo" />
  )
}

export default Logo;